import { FieldConfig } from "@/components/form-builder";
import { MARITAL_STATUS_OPTIONS, PRONOUNS_OPTIONS } from "@/pages/register-person/constants/marital-status-options";

export const personalInfoFields: FieldConfig[] = [
  { name: "completeName", type: "text", label: "Nome Completo", required: true },
  { name: "socialName", type: "text", label: "Nome Social" },
  { name: "artisticName", type: "text", label: "Nome Artístico" },
  { name: "role", type: "text", label: "Função", required: true },
  { name: "rg", type: "rg", label: "Nº RG", placeholder: "Digite o número do seu RG", required: true },
  { name: "cpf", type: "cpf", label: "Nº CPF", required: true },
  { name: "birthDate", type: "date-inline", label: "Data de Nascimento", required: true },
  { name: "birthPlace", type: "text", label: "Local de Nascimento (cidade e estado)", required: true },
  { name: "nationality", type: "text", label: "Nacionalidade", required: true },
  { name: "countryEntryDate", type: "date-inline", label: "Data de Entrada no País (caso se aplique)" },
  {
    name: "maritalStatus",
    type: "select",
    label: "Estado Civil",
    required: true,
    options: MARITAL_STATUS_OPTIONS,
  },
  {
    name: "pronouns",
    type: "select",
    label: "Pronomes",
    required: true,
    options: PRONOUNS_OPTIONS,
  },
  { name: "cellphone", type: "phone", label: "Celular", required: true },
  { name: "tshirtNumber", type: "text", label: "Número da Camiseta" },
]

export const addressFields: FieldConfig[] = [
  { name: "zipCode", type: "cep", label: "CEP", required: true },
  { name: "residentialAddress", type: "text", label: "Endereço residencial (PF)", required: true },
  { name: "district", type: "text", label: "Bairro (PF)", required: true },
  { name: "city", type: "text", label: "Cidade (PF)", required: true },
  { name: "state", type: "text", label: "Estado (PF)", required: true },
]

export const healthFields: FieldConfig[] = [
  { name: "healthPlan", type: "text", label: "Plano de Saúde" },
  { name: "planCoverage", type: "text", label: "Cobertura do Plano" },
  { name: "emergencyContact", type: "text", label: "Contato de Emergência" },
  { name: "bloodType", type: "text", label: "Tipo Sanguíneo" },
  { name: "allergies", type: "text", label: "Alergias" },
  { name: "coronavirusVaccination", type: "text", label: "Vacinação Covid-19" },
  { name: "dietaryRestrictions", type: "text", label: "Restrições Alimentares" },
]

export const bankFields: FieldConfig[] = [
  { name: "bank", type: "text", label: "Banco" },
  { name: "branch", type: "text", label: "Agência" },
  { name: "checkingAccount", type: "text", label: "Conta Corrente" },
  { name: "pixKey", type: "text", label: "Chave Pix" },
]
